import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'apps/iqc-hr/src/environments/environment';

@Component({
  selector: 'iq-central-front-end-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  destinationUrl = `${environment.FRONTEND_HOMEPAGE_URL}/login`;

  // destinationUrl = 'http://localhost:4200/login';
  userDetails: any;
  userId: any;
  enterpriseUserId: any;
  mentorId: boolean;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _jwt: JwtHelperService
  ) {}

  selected = '';
  ngOnInit() {
    this.getLoggedInUser();
  }
  loggedIn(): boolean {
    const token = localStorage.getItem('token');
    return (
      localStorage.getItem('token') !== null || !this._jwt.isTokenExpired(token)
    );
  }

  getLoggedInUser() {
    if (this.loggedIn()) {
      const token = localStorage.getItem('token');
      this.userDetails = this._jwt.decodeToken(token);
      this.userId = this.userDetails.user_id;
      this.enterpriseUserId = this.userDetails.enterprise_user_id;
      this.mentorId = this.userDetails.isMentor;
    }
  }
  goToStaff() {
    this.router.navigate(['/staff']);
  }

  logOut() {
    localStorage.removeItem('token');
    window.location.href = this.destinationUrl;
  }
}
